import { h, createApp } from 'vue'
import { setBaseWebInfo } from '@/utils/index'
import App from './App.vue'
import pinia from './store'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import './style/index'
import './style/index.less'
import { analysis } from '@/utils/sa/analysis'
import { ElLoading, ElTable, ElTableColumn } from 'element-plus'
import 'element-plus/dist/index.css'

// svg引用
import 'virtual:svg-icons-register'
import { locale } from 'dayjs'
setBaseWebInfo()
const app = createApp(App)
app.use(ElTable).use(ElTableColumn).use(ElLoading)
app.config.globalProperties.$analysis = analysis
app.use(pinia).use(router).use(Antd).mount('#app')
